// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1LbdT","filesListContainer":"PosDisputesFiles_filesListContainer__1r9_M","filesButton":"PosDisputesFiles_filesButton__Ozson"};